import React from "react";

const AccountingHint = ({ hint }) => {
  return (
    <div
      className="d-flex align-items-start"
      style={{
        borderRadius: 14,
        padding: "12px 14px",
        background:
          "linear-gradient(135deg, rgba(0,123,255,0.08), rgba(240,245,255,0.9))",
        border: "1px solid rgba(0,123,255,0.18)",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center mr-3"
        style={{
          width: 34,
          height: 34,
          borderRadius: 10,
          background: "rgba(0,123,255,0.15)",
          border: "1px solid rgba(0,123,255,0.25)",
          flexShrink: 0,
        }}
      >
        <i className="fa fa-info text-primary" />
      </div>

      <div style={{ fontSize: 13, lineHeight: 1.5 }}>
        <div className="font-weight-semibold text-primary mb-1">
          Accounting Insight
        </div>
        <div className="text-muted">{hint}</div>
      </div>
    </div>
  );
};

export default AccountingHint;
